<template>
    <div>
       <!-- 我是shopDashboard -->
    </div>
</template>
<script>
    export default {
        name:'shopDashboard'
    }
</script>
